module.exports = __webpack_public_path__ + "static/img/nav_logo_primary.7541579.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/nav_logo_primary.png
// module id = 429
// module chunks = 180